import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { CommonService } from 'src/app/core/services/common.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';
import { TokenStorage } from 'src/app/core/services/token.service';

@Component({
  selector: 'app-get-access-code',
  templateUrl: './get-access-code.component.html',
  styleUrls: ['./get-access-code.component.scss']
})
export class GetAccessCodeComponent {
  accessCode: any;
  url: any;
  redirectURL: any;
  isLoading: boolean = true; // Initially loading is true
  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private loader: LoaderService,
    private router: Router,
    private restService: RestService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private authService: AuthService,
    private token: TokenStorage
  ) {
    this.url = window.location.href;
    this.accessCode = this.extractDomainIdFromUrl(this.url);
    localStorage.clear();
    this.getCode();
  }

  ngOnInit(): void {
    
  }

  private extractDomainIdFromUrl(url: string): string | null {
    const urlObject = new URL(url);
    const domainId = urlObject.searchParams.get('auth');
    return domainId;
  }
  getCode() {
    //alert("access code api calling");
   // this.loader.show();
    let params = {
      accessCode: this.accessCode,
    };
    this.restService
      .postUADLogin(params, 'api/UAD/GetTokenByAccessCode')
      .subscribe(
        (data) => {
          if (data.rcode == 200) {
            //this.loader.hide();
            this.isLoading = false;
            this.authService.isToken(data.rObj.token ? true : false);
            this.authService.b2cAttemptAuth(data.rObj.token);
            this.authService.saveRefreshToken(data.rObj.refreshToken);
            this.authService.expiryDateTime(data.rObj.expiryTime);
            this.redirectURL = '/dashboard';
            //this.loader.hide();
            this.isLoading = false;
            window.location.href = this.redirectURL
          } else {
            alert('unauthorized');
          }
        },
        (error) => {}
      );
  }

}
